import { DELETE_CUSTOMER, EDIT_CUSTOMER_CONTACT, EDITED_CUSTOMER, STOP_LOADING, CREATE_CUSTOMER_CONTACT, CREATE_CUSTOMER, GET_CUSTOMER, GET_CUSTOMER_CONTACTS, CREATE_CUSTOMER_SUCCESS, ERROR } from './types';
import { API_URL } from "../constants";
import globalAxios from '../util/Api'
import { GetCountries } from '../container/Land/LandActions';
import { LogoutAction } from './logout';

export const CreateCustomer = (name, shortname, active, country_id, street, zipcode, city, mail, phone, faxno, comment) => {
  return (dispath) => {

    dispath({
      type: CREATE_CUSTOMER
    })

    globalAxios().post(API_URL + '/api/v1/customers', {
      name: name,
      shortname: shortname,
      active: active,
      country_id: country_id,
      street: street,
      zipcode: zipcode,
      city: city,
      mail: mail,
      phone: phone,
      faxno: faxno,
      comment: comment
    })
      .then((resp) => {
        dispath({
          type: CREATE_CUSTOMER_SUCCESS,
          payload: resp.data.customer
        })
        dispath(GetCustomer())
      }).catch(err => {
        if (err.response)
          dispath({ type: ERROR, payload: err.response.data.customer })
      })
  }
};

export const EditCustomer = (customerId, name, shortname, active, country_id, street, zipcode, city, mail, phone, faxno, comment) => {

  return (dispatch) => {
    dispatch({
      type: CREATE_CUSTOMER
    })
    globalAxios().put(`/api/v1/customers/${customerId}`, {
      name: name,
      shortname: shortname,
      active: active,
      country_id: country_id,
      street: street,
      zipcode: zipcode,
      city: city,
      mail: mail,
      phone: phone,
      faxno: faxno,
      comment: comment
    })
      .then(res => {
        if (res) {
          dispatch({ type: EDITED_CUSTOMER, payload: res.data.customer });
          dispatch(GetCustomer())
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.customer })
      })
  }
}

export const EditCustomerContact = (customerId, editContactId, editContactFirstName, editContactlastName, editContactActive, editContactAnrede, editContactTitel, editContactFunktion, editContactTelefon, editContactEmail) => {

  return (dispatch) => {
    dispatch({
      type: CREATE_CUSTOMER
    })
    globalAxios().put(`/api/v1/customer_contacts/${editContactId}`, {
      firstname: editContactFirstName,
      lastname: editContactlastName,
      active: editContactActive,
      salutation: editContactAnrede,
      title: editContactTitel,
      function: editContactFunktion,
      phone: editContactTelefon,
      mail: editContactEmail,
      customer_id: customerId
    })
      .then(res => {
        if (res) {
          dispatch({
            type: EDIT_CUSTOMER_CONTACT,
            payload: res.data.customer_contact
          })
          dispatch(GetCustomer());
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.customer })
      })
  }
}

export const CreateCustomerContact = (customerId, createContactFirstName, createContactlastName, createContactActive, createContactAnrede, createContactTitel, createContactFunktion, createContactTelefon, createContactEmail) => {
  return (dispatch) => {
    dispatch({
      type: CREATE_CUSTOMER
    })
    globalAxios().post(`/api/v1/customer_contacts/`, {
      firstname: createContactFirstName,
      lastname: createContactlastName,
      active: createContactActive,
      salutation: createContactAnrede,
      title: createContactTitel,
      function: createContactFunktion,
      phone: createContactTelefon,
      mail: createContactEmail,
      customer_id: customerId
    })
      .then(res => {
        if (res) {
          dispatch({
            type: CREATE_CUSTOMER_CONTACT,
            payload: res.data.customer_contact
          })
          dispatch(GetCustomer());
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.customer })
      })
  }
}

export const GetCustomer = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/customers`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_CUSTOMER, payload: res.data.customers })
          dispatch(GetCountries())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })

  }
}

export const GetCustomerContacts = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/customer_contacts`, {
      params: {
        customer_id: JSON.parse(localStorage.getItem("user")).id
      }
    })
      .then(res => {
        if (res) {
          dispatch({ type: GET_CUSTOMER_CONTACTS, payload: res.data.contacts })
        }
      })
  }
}

export const DeleteCustomerContact = (customerContactId) => {
  return (dispatch) => {
    dispatch({
      type: CREATE_CUSTOMER
    })
    globalAxios().delete(`/api/v1/customer_contacts/${customerContactId}`)
      .then(res => {
        if (res) {
          dispatch({ type: DELETE_CUSTOMER, payload: res.data.success })
          dispatch(GetCustomer());
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.customer })
      })
  }
}